<header
  class="flex flex-wrap items-center justify-between bg-white border-b border-border-light px-6 py-3"
>
  <a routerLink="/" class="flex items-center gap-3 text-text-primary">
    <img
      src="./favicon/apple-touch-icon.png"
      alt="Rechtly Logo"
      class="h-8 w-8"
    />
    <h1 class="text-xl font-bold tracking-tighter">Rechtly</h1>
  </a>
  <nav
    class="flex flex-wrap w-full justify-center gap-x-6 gap-y-2 pt-3 text-base order-3 md:flex-nowrap md:w-auto md:order-2 md:pt-0 md:gap-8"
  >
    <a
      routerLink="/workspace"
      routerLinkActive="header-nav-link-active"
      class="header-nav-link smooth-transition"
      >{{ 'header.workspace' | transloco }}</a
    >
    <a
      routerLink="/library"
      routerLinkActive="header-nav-link-active"
      class="header-nav-link smooth-transition"
      >{{ 'header.library' | transloco }}</a
    >

    <a
      routerLink="/practice"
      routerLinkActive="header-nav-link-active"
      class="header-nav-link smooth-transition"
      >{{ 'header.practice' | transloco }}</a
    >
  </nav>
  <div class="flex items-center gap-2 order-2 md:order-3">
    <app-language-switcher />
    <a
      class="icon-avatar bg-center bg-no-repeat aspect-square bg-cover rounded-full size-10"
      routerLink="/profile"
    >
    </a>
  </div>
</header>
